import axios from 'axios';
import Toast from 'vant/lib/toast';
import URL from '@/util/url';
import STATUS from '@/constants/status';
import Store from '@/store/index';

const bizlogintoken = URL.getParameterByKey('bizlogintoken') || sessionStorage.getItem('bizlogintoken') || '';
const ERR_NAME = 'API-ERROR';
const SUCCESS_STATUS_CODE = 1000;
const FAIL_STATUS_CODE = 10000;

axios.defaults.timeout = 20000; // 响应时间
// 指定允许其他域名访问
axios.defaults.withCredentials = true; // 跨域cookie共享
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; // 配置请求头

let fetchTime;
const queue = {};
axios.interceptors.request.use(
  (config) => {
    config.startTime = new Date().getTime();
    queue[config.url + config.startTime] = {
      path: config.url,
    };
    const { bizlogintoken: token } = Store.state;

    if (!config.delToken) config.headers.bizlogintoken = bizlogintoken || token;
    if (config.method === 'post' || config.method === 'put') {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  }, (err) => Promise.reject(err),
);

axios.interceptors.response.use(
  (response) => {
    const { respCode, code } = response.data || {};
    const { url, startTime } = response.config || {};
    const urlKey = url + startTime;
    const responseCode = respCode === undefined ? Number(code) : respCode;
    if (queue[urlKey] && (queue[urlKey].path === url)) {
      fetchTime = new Date().getTime() - startTime;
    }

    delete queue[urlKey];
    if (responseCode === STATUS.AUTH_ERROR || responseCode === STATUS.GATEWAY_AUTH_ERROR) {
      const { bizlogintoken: token } = Store.state;
      const options = {
        tags: {
          bizlogintoken: bizlogintoken || token, url, responseCode, from: 'axios interceptor',
        },
      };
      Owl.addError('noAuth', options);
      Toast(`${url}请求失败`);
      window.location.href = '/noAuth';
      return response.data;
    }
    Owl.addApi({
      name: url,
      statusCode: responseCode === STATUS.SUCCESS ? SUCCESS_STATUS_CODE : FAIL_STATUS_CODE,
      networkCode: 200,
      responseTime: fetchTime,
    });
    return response.data;
  }, (error) => {
    const { status, config } = error.response || {};
    const { code: eCode } = (error.response && error.response.data) || {};
    const {
      url, params, data, startTime,
    } = config || {};
    const urlKey = url + startTime;
    if (queue[urlKey] && queue[urlKey].path === url) {
      fetchTime = new Date().getTime() - startTime;
    }
    delete queue[urlKey];
    if (error.response) {
      Owl.addApi({
        name: ERR_NAME,
        statusCode: FAIL_STATUS_CODE,
        networkCode: 500,
        content: `请求失败
      errorCode-${eCode}
      httpStatus-${status}
      url-${url}
      params-${JSON.stringify(params || data)}`,
      });
    } else {
      Owl.addError(error, {
        tags: error,
      });
    }

    return {
      data: null,
      error: {
        code: status,
        msg: error.message,
      },
    };
  },
);

export default axios;
